import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { SecureStorageService } from "../../services/secure-storage.service";

@Injectable({
  providedIn: "root",
})
export class StarGuard implements CanActivate {
  constructor(
    private secureStorage: SecureStorageService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const token = this.secureStorage.getItem<string>("token");
    const rang = this.resolveRang();
    if (token && rang === "star") {
      return true;
    }
    this.router.navigate(["/streams"]);
    return false;
  }

  private resolveRang(): string {
    const rangDirect = this.secureStorage.getItem<string>("rang");
    if (rangDirect && typeof rangDirect === "string") {
      return rangDirect.toLowerCase().trim();
    }
    const user = this.secureStorage.getItem<{ rang?: string }>("user");
    return (user?.rang || "").toString().toLowerCase().trim();
  }
}
